import { useCloseVJ } from "./useCloseVJ";

import { useNavigation } from "@react-navigation/native";
import { useEffect } from "react";
import { BackHandler, Platform } from "react-native";

/**
 * Registers the Android hardware / gesture back handler for View Job: pop the RN stack if
 * possible, otherwise close the View Job container. Shared by both the REST (`AppContent`) and
 * OneGraph (`AppContentGraphQL`) entry points so their back behavior can't drift apart.
 */
export function useViewJobAndroidBackHandler(): void {
  const navigation = useNavigation();
  const closeVJ = useCloseVJ();

  useEffect(() => {
    if (Platform.OS !== "android") {
      return;
    }

    const subscription = BackHandler.addEventListener("hardwareBackPress", () => {
      if (navigation.canGoBack()) {
        navigation.goBack();
        return true;
      }
      closeVJ();
      return true;
    });

    return () => {
      subscription.remove();
    };
  }, [closeVJ, navigation]);
}
